import { NextResponse } from "next/server";
import { apiFetch, ApiError } from "@/lib/api/client";
import { getSession } from "@/lib/auth/session";

// Proxy vers POST /api/mobile/totp/verify.php — confirme le 1er code TOTP et
// active definitivement le 2FA sur le compte super-admin courant. Le user
// reste authentifié avec la même session (pas de nouveau access_token).

export async function POST(request: Request) {
  const session = await getSession();
  if (!session) {
    return NextResponse.json(
      { success: false, error: "Session expirée" },
      { status: 401 },
    );
  }

  let payload: { code?: unknown };
  try {
    payload = await request.json();
  } catch {
    return NextResponse.json(
      { success: false, error: "Requête invalide" },
      { status: 400 },
    );
  }

  const code = typeof payload.code === "string" ? payload.code.trim() : "";
  if (!/^\d{6}$/.test(code)) {
    return NextResponse.json(
      { success: false, error: "Code à 6 chiffres requis" },
      { status: 400 },
    );
  }

  try {
    const body = await apiFetch<{ success: boolean; message?: string }>(
      "/mobile/totp/verify.php",
      {
        method: "POST",
        token: session.token,
        body: { code },
      },
    );
    if (!body.success) {
      return NextResponse.json(
        { success: false, error: body.message ?? "Code invalide" },
        { status: 401 },
      );
    }
    return NextResponse.json({ success: true });
  } catch (err) {
    if (err instanceof ApiError && err.status === 401) {
      return NextResponse.json(
        { success: false, error: "Code TOTP invalide" },
        { status: 401 },
      );
    }
    if (err instanceof ApiError) {
      return NextResponse.json(
        { success: false, error: err.message ?? "Erreur backend" },
        { status: err.status },
      );
    }
    console.error("[auth/totp/verify] upstream error:", err);
    return NextResponse.json(
      { success: false, error: "Service d'authentification indisponible" },
      { status: 502 },
    );
  }
}
